import SettingsContainer from './settings_container';

const Settings = SettingsContainer;
export default Settings;
